export default __webpack_public_path__ + "static/screenSixthSectionEn-58880a6001bacab211196cf93cfe6e7e.webp";